import { createFileRoute } from '@tanstack/react-router';
import { AdminOverview } from '../../features/settings/components/overview-page.js';

export const Route = createFileRoute('/admin/')({ component: AdminOverview });
